import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { NowUser } from './models';
import { StoreAction } from 'store/actions';
import { ApiChannel } from 'core/constants';
import { buildHeaders, XmStore } from 'core/services';
import { ModelBase } from '../../model-base';

@Injectable()
export class NowUserApi {
    public static getUserInfo(_xmStore: XmStore, http: HttpClient): Observable<NowUser> {
        return http.get('/csp/account/now', {
            headers: buildHeaders({ apiChannel: ApiChannel.SSM_GATEWAY })
        }).pipe(
            map((response: ApiResponse) => NowUser.create<NowUser>(response))
        );
    }
}

ModelBase.fetchMapping[StoreAction.GET_USER_INFO] = NowUserApi.getUserInfo;
